import { getTextFormat, TEXT_FORMAT_IDS } from '../../core';
import { getProFormat, PRO_FORMAT_IDS, type ProFormatId } from '../../core/formats/pro';
import type { TargetId } from '../session/exportDownload';

const PRO_IDS = PRO_FORMAT_IDS as readonly ProFormatId[];

/**
 * The Free/Pro target-format `<select>`, shared by the Converter, the Studio
 * in-place Export, and the Batch panel (cue-forge-zxw.10) — they carried three
 * copies of the same optgroup markup. Pro options get a lock glyph for free
 * users (visible-but-locked, spec §7.5); the label text and aria-label vary per
 * site, so both are props. Wrapped in a labelled `cf-field` like the originals.
 */
export function FormatPicker({
  label,
  ariaLabel,
  value,
  onChange,
  isPro,
}: {
  label: string;
  ariaLabel: string;
  value: TargetId;
  onChange: (id: TargetId) => void;
  isPro: boolean;
}) {
  return (
    <label className="cf-field">
      <span>{label}</span>
      <select
        aria-label={ariaLabel}
        className="cf-select"
        value={value}
        onChange={(e) => onChange(e.target.value as TargetId)}
      >
        <optgroup label="Free">
          {TEXT_FORMAT_IDS.map((id) => (
            <option key={id} value={id}>
              {getTextFormat(id).name}
            </option>
          ))}
        </optgroup>
        <optgroup label="Pro">
          {PRO_IDS.map((id) => (
            <option key={id} value={id}>
              {getProFormat(id).name}
              {isPro ? '' : ' \u{1F512}'}
            </option>
          ))}
        </optgroup>
      </select>
    </label>
  );
}
